import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const SalesTopSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">분양안내</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('sky-special-room') || location.pathname.includes('sky-hall-phoenix-room')
                            || location.pathname.includes('sky-hall-vip-sales') || location.pathname.includes('star-hall-sales')
                            || location.pathname.includes('sunlight-hall-sales') || location.pathname.includes('s-hall-sales')
                            || location.pathname.includes('outdoor-hall-sales') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('sky-special-room');
                        }}
                    >
                        분양가격
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('sales-info') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('sales-info');
                        }}
                    >
                        분양안내
                    </a>
                </div>
            </section>

        </>
    )
}

export default SalesTopSection;